import { api } from "@/redux/api";

import {
	CreateFundingMa,
	FundingMa,
	FundingMaSchema,
} from "../../pages/FundingMa/schema/funding-ma";
import {
	FundingSignalResponse,
	FundingSignalResponseSchema,
} from "../../pages/FundingMa/schema/leadsOnTrees";

export const fundingMaApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createFundingMa: builder.mutation<FundingMa, CreateFundingMa>({
			query: (body) => ({
				url: `funding-ma`,
				method: "POST",
				body,
				responseSchema: FundingMaSchema,
			}),
			invalidatesTags: (result, error, arg) => {
				if (arg.listId) {
					return [{ type: "List", id: arg.listId }, "FundingMa"];
				}

				return ["FundingMa"];
			},
		}),
		previewFundingMa: builder.mutation<FundingSignalResponse, CreateFundingMa>({
			query: (body) => ({
				url: `funding-ma/preview`,
				method: "POST",
				body,
				responseSchema: FundingSignalResponseSchema,
			}),
		}),
		updateFundingMa: builder.mutation<Partial<FundingMa>, Partial<FundingMa> & { listId?: number }>(
			{
				query: ({ id, ...body }) => ({
					url: `funding-ma/${id}`,
					method: "PATCH",
					body,
					responseSchema: FundingMaSchema,
				}),
				invalidatesTags: (result, error, arg) => {
					if (arg.listId) {
						return [{ type: "List", id: arg.listId }, "FundingMa"];
					}

					return ["FundingMa"];
				},
			}
		),
		deleteFundingMa: builder.mutation<{ id: number }, { id: number; listId?: number }>({
			query: ({ id }) => ({
				url: `funding-ma/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: (result, error, arg) => {
				if (arg.listId) {
					return [{ type: "List", id: arg.listId }, "FundingMa"];
				}

				return ["FundingMa"];
			},
		}),
	}),
});

export const {
	useCreateFundingMaMutation,
	useUpdateFundingMaMutation,
	useDeleteFundingMaMutation,
	usePreviewFundingMaMutation,
} = fundingMaApi;
export const fundingMaApiReducer = fundingMaApi.reducer;
export const fundingMaApiMiddleware = fundingMaApi.middleware;
